import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { Folder } from './types';
import { SEQUENCES_LIST_KEY } from 'queries/sequences/useSequencesFolders';
import { useTranslation } from 'react-i18next';

function createFolder({
  folder,
  sequenceId,
}: {
  folder: Folder;
  sequenceId?: string;
}) {
  const requestURL = '/folders';
  return request(requestURL, {
    method: 'POST',
    body: {
      id: folder.id,
      name: folder.name,
      parentId: folder.parentId,
      position: folder.position,
      sequenceId,
    },
  });
}

export function useCreateFolder() {
  const { notifyError } = useNotification();
  const { t } = useTranslation(['sequence']);
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation({
    mutationFn: ({ sequenceId, ...folder }: Folder & { sequenceId?: string }) =>
      createFolder({
        folder,
        sequenceId,
      }),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [SEQUENCES_LIST_KEY],
      });
    },
    onError: () => {
      notifyError({
        title: t('sequence:messages.folder.createError'),
      });
    },
  });
  return mutateAsync;
}
